import React from 'react';

import {
  ReferenceManyField,
  usePermissions,
} from 'react-admin';

import {
  Grid,
  Card,
  CardHeader,
  Divider,
  CardContent,
  Box,
} from '@mui/material';

import Pagination from '../components/layout/Pagination';

import { BusinessListBody } from '../components/business/BusinessList';
import actions, { Actions } from '../constants/actions';
import hasAccess from '../utilities/hasAccess';
import PermissionMissing from '../components/utils/PermissionMissing';

const RelatedConductions = () => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Grid size={12}>
      <Card variant="outlined">
        <CardHeader
          title="Related conductions"
        />
        <Divider />
        {hasAccess(permissions, actions.BUSINESS_LIST) ? (
          <ReferenceManyField
            perPage={5}
            pagination={<Pagination disableEmptyText rowsPerPageOptions={[5, 10, 20]} />}
            reference="businesses"
            source="id"
            target="conductors.id"
          >
            <BusinessListBody />
          </ReferenceManyField>
        ) : (
          <CardContent>
            <Box display="flex" alignItems="center" width="100%" flexDirection="column">
              <PermissionMissing />
            </Box>
          </CardContent>
        )}
      </Card>
    </Grid>
  );
};

export default RelatedConductions;
